<template>
  <div id="GameInformation">
    <div style="position: absolute; bottom: -100px; left: 50%; transform: translate(-50%, 0);">
      <div style="display: flex; justify-content: space-between; align-items: flex-end; color: white; width: 660px">
        <score-board
          :score-board-team-name="ATeamName"
          :score-board-team-score="red_score"
        />
        <div>
          <div style="position: relative; top: 30px">
            <div style="position: absolute; top: 40%; left: 50%; transform: translate(-50%, -40%); text-align: center; font-size: 22px;">
              {{ NowCount }}</div>
            <div style="position: absolute; top: 73%; left: 50%; transform: translate(-50%, -73%); font-size: 12px">秒</div>
            <img :src="TimerImg" alt="" style="width: 70px;">
          </div>
        </div>
        <score-board
            :score-board-team-name="BTeamName"
            :score-board-team-score="white_score"
        />
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import TimerImg from "@/assets/time.png"
import ScoreBoard from "./ScoreBoard";
import dayjs from "dayjs";

export default {
  name: "GameInformation",
  components: {
    ScoreBoard
  },
  props: {
    red_score: {
      type: Number,
      default: 0
    },
    white_score: {
      type: Number,
      default: 0
    },
    game_flag: {
      type: String,
      default: 'ready'
    },
    room_id: {
      type: String,
      default: ''
    },
    game_end_time: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      TimerImg: TimerImg,
      ATeamName: "Aチーム",
      BTeamName: "Bチーム",
      NowCount: 30,
    }
  },
  methods: {
    countDownTimer() {
      let _game_end_time
      if (this.game_end_time === '') {
        _game_end_time = dayjs().add(30, 's').format()
      } else {
        _game_end_time = dayjs(this.game_end_time)
      }
      //console.log(this.game_end_time)
      const nowTime = dayjs();
      const endTime = _game_end_time;
      const diffTime = endTime.diff(nowTime, 'second', false);

      // console.log(Math.sign(diffTime))

      if (Math.sign(diffTime) !== -1) {
        // NOTE: 制限時間までの残り秒数をカウントに代入
        this.NowCount = diffTime
      } else {
        this.NowCount = 0
        this.updateGameEnd()
      }

      if(this.NowCount > 0) {
        setTimeout(() => {
          this.NowCount -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.updateGameEnd()
      }
    },
    updateGameEnd() {
      firebase.database().ref('rooms/' + this.room_id).update({
        game_flag: 'end'
      });
    }
  },
  mounted() {
    if (this.game_flag === 'start') {
      this.countDownTimer();
    }
  },
  watch: {
    game_flag: function (val) {
      if (val === 'start') {
        this.countDownTimer();
      }
    }
  }
}
</script>

<style scoped>

</style>
